import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}

import Api from '@/services/api';
    import { Event } from '@/services/types';
    import { ElForm, ElDatePicker, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem, ElButton } from 'element-plus';
    import { reactive, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEvent',
  setup(__props) {

    const router = useRouter()
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const store = useStore()

    const event = reactive<Event>({
        type: '',
        description: '',
        event_time: new Date(),
        image: null,
        name: '',
        places: 0,
        price: 0.01,
        vip_price: 0.01,
        vips: 0,
        area: {lat: 18.34, long: 34.18, name: ''}
    })

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            event.image = URL.createObjectURL(files[0])
        }
    }
    
    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (event.area) {
            event.area.lat = lat
            event.area.long = lng
        } else {
            event.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(event.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (event.area) {
                event.area.lat = position.coords.latitude
                event.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!event.area?.lat || !event.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(event)
                if (image.value) {
                    formData.append("image", image.value)
                }

                const res = await Api.post('/admin/events', event, formData)
                if (res.status == 200) {
                    store.commit('setOpenModal', -1)
                    router.push('/events/' + res.data.event.id)
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    event
      ? (_openBlock(), _createBlock(_unref(ElForm), {
          key: 0,
          disabled: saving.value,
          model: event,
          "label-position": "top",
          rules: rules.value,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              label: "Nome do evento",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  name: "name",
                  modelValue: event.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((event.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Imagem promocional",
              prop: "image"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"max-height":"250px","max-width":"100%"},
                  src: (event.image as string)
                }, null, 8, _hoisted_2),
                _createElementVNode("input", {
                  type: "file",
                  name: "image",
                  onChange: changeFile
                }, null, 32)
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Tipo do evento",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  name: "type",
                  modelValue: event.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((event.type) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Data e hora",
              prop: "event_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElDatePicker), {
                  type: "datetime",
                  format: "DD/MM/YYYY HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  name: "event_time",
                  clearable: false,
                  modelValue: event.event_time,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.event_time) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Descricao do evento",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "textarea",
                  name: "description",
                  modelValue: event.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((event.description) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElButton), {
              plain: "",
              type: "primary",
              disabled: event.price == 0,
              onClick: _cache[4] || (_cache[4] = () => {event.price = 0; event.vip_price = 0})
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Evento gratis ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (event.price == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Este evento é gratís"))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElCol), {
                  sm: 12,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElFormItem), {
                      label: "Preço normal",
                      prop: "price"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInputNumber), {
                          name: "price",
                          modelValue: event.price,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((event.price) = $event)),
                          step: 0.001,
                          min: 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElCol), {
                  sm: 12,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElFormItem), {
                      label: "Preço VIP",
                      prop: "vip_price"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInputNumber), {
                          name: "vip_price",
                          modelValue: event.vip_price,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((event.vip_price) = $event)),
                          step: 0.001,
                          min: 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(ElRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElCol), {
                  sm: 12,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElFormItem), {
                      label: "Nr de lugares normais",
                      prop: "places"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInputNumber), {
                          name: "places",
                          modelValue: event.places,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((event.places) = $event)),
                          step: 1,
                          min: 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElCol), {
                  sm: 12,
                  md: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElFormItem), {
                      label: "Nr de lugares VIP",
                      prop: "vips"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElInputNumber), {
                          name: "vips",
                          modelValue: event.vips,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((event.vips) = $event)),
                          step: 1,
                          min: 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (event.area)
              ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                  key: 1,
                  label: "Local",
                  prop: "area.name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      name: "area",
                      modelValue: event.area.name,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((event.area.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(ElButton), {
                plain: "",
                class: "position-absolute end-0",
                style: {"z-index":"1024"},
                loading: locating.value || saving.value,
                size: "large",
                type: "success",
                onClick: _withModifiers(locate, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Localizar-me ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              (event.area)
                ? (_openBlock(), _createBlock(_unref(LMap), {
                    key: 0,
                    onContextmenu: onMapClick,
                    ref: "map",
                    zoom: 16,
                    center: [event.area.lat, event.area.long]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LTileLayer), {
                        url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                        "layer-type": "base",
                        name: "OpenStreetMap"
                      }),
                      (event.area)
                        ? (_openBlock(), _createBlock(_unref(LMarker), {
                            key: 0,
                            "lat-lng": [event.area.lat, event.area.long]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(LTooltip), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(event.name), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["lat-lng"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["center"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["disabled", "model", "rules"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(ElRow), {
      justify: "space-between",
      class: "py-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { class: "col-auto" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElButton), {
              type: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (submit(formRef.value))),
              plain: "",
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Salvar e publicar ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})